import { RouterModule, Routes } from '@angular/router';
import { PlanesComponent } from './planes.component';

const PlansRoutes: Routes = [
  {
    path: '',
    component: PlanesComponent,
  },
];

export const MAIN_PLANS = RouterModule.forChild(PlansRoutes);
